export default class ProspectCityClientsModel {
  cliente!: string;

  cnpj!: string;

  representante!: string;

  situacaoErp!: string;

  situacaoGestao!: string;

  endereco!: string;

  dataUltimaCompra!: string;

  valorUltimaCompra!: number;

  qtdePecasUltimaCompra!: number;

  qtdePedidos!: number;

  ticketMedioValor!: number;

  mediaPecas!: number;

  clienteAtivoMaisProximo!: string;

  distanciaClienteAtivoMaisProximo!: number;

  clienteAtivoPedidoMaisRecente!: string;

  distanciaClienteAtivoPedidoMaisRecente!: number;

  valorClienteAtivoPedidoMaisRecente!: number;

  municipioCliente!: string;

  municipioClientePopulacao!: string;

  utilizandoDistanciaComRota!: boolean;

  situacaoGeocodificacao?: 'PENDENTE' | 'NAO_LOCALIZADO' | null;
}
